<script setup lang="ts">
import { Megaphone } from '@lucide/vue';
</script>

<template>
    <megaphone class="inline text-blue-700" />
</template>
